import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { ReportAdapterService } from '../../services/report-adapter.service';
import { ReportAnalysisAPIService } from '../../services/report-analysis-api.service';
import { ReportAnalysisService } from '../../services/report-analysis.service';
import * as ReportActions from './final-report.actions';

@Injectable()
export class FinalReportEffect {
    private _actions$ = inject(Actions);
    private _store = inject(Store);
    private reportAPI = inject(ReportAnalysisAPIService);
    private reportAnalysis = inject(ReportAnalysisService);
    private adapter = inject(ReportAdapterService);

    // -----------------------------------------------------------
    // @ Effects
    // -----------------------------------------------------------
    // -----------------------------------------------------------
    // @ Final Report Effects
    // -----------------------------------------------------------

    generateFinalReport$ = createEffect(() =>
        this._actions$.pipe(
            ofType(ReportActions.generateFinalReport),
            switchMap(() =>
                this.reportAPI.getFinalReport().pipe(
                    // Debug
                    // tap((res) => {
                    //     console.log('getFinalReport:', res);
                    // }),
                    map((res) => this.adapter.adaptFinalReport(res.data)),
                    map((report) =>
                        ReportActions.generateFinalReportSuccess({
                            report,
                        })
                    ),
                    catchError((error) =>
                        of(
                            ReportActions.generateFinalReportFailure({
                                error: error.error?.message || 'Unknown Error',
                            })
                        )
                    )
                )
            )
        )
    );
}
